import { runDemo } from "../shared/demoRunner";
import { createHeartScene } from "./scene";

runDemo({ createScene: createHeartScene });
